<template>
  <PortalHeader />
</template>

<script>
import storageService from "@/services/storage.service";
import PortalHeader from "./portal-header.vue";
import axios from "axios";

// Header used by the admin and staff screens. The visual part lives in portal-header.vue
// (same look as the applicant header, with the menu of the logged-in role).
export default {
  components: {
    PortalHeader,
  },
  mounted() {
    this.getAuthenticatedUser();
  },
  methods: {
    getAuthenticatedUser() {
      const email =
        storageService.getItem("email") ||
        storageService.getItem("userEmail") ||
        "";
      let data = new FormData();
      data.append("email", email);
      axios
        .post("api/getAuthenticatedUser/", data)
        .then((res) => {
          this.$store.state.authenticatedUser = res.data;
        })
        .catch((error) => {
          console.error("Could not fetch authenticated user:", error);
        });
    },
  },
};
</script>